<div id="driver-wizard"
     class="row ">
     <div class="d-flex justify-content-between align-items-center card-title"
          id="page-title">
          <h1 *ngIf="!service.justSubscribe"
              [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>

          <h1 *ngIf="service.justSubscribe"
              [innerHtml]="'RecordMonitoring' | translator: 'base'">
               Subscribe to PSP Driver Monitoring
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="1"
                                      [totalSteps]="11">
                    </app-complete-bar>
                    <div class="overlay"
                         *ngIf="isVerifying">
                         <h1 class="heading"
                             [innerHtml]="'Verifying' | translator: 'base'">
                              Verifying...
                         </h1>
                         <img />
                    </div>
                    <h2 [innerHtml]="'CreateAccount' | translator: 'base'">Create Account</h2>
                    <div class="justify-content-md-center form-group form-inline">
                         <p class="step-text"
                            [innerHtml]="'CreateAccountHelp' | translator: 'base'">
                              Now, we need your email address. This will be used so that you can login later and view
                              your records. Once you have
                              created your account, you will receive an email with instructions for creating a PSP
                              Login.gov account.
                         </p>

                         <div class="row gx-2">
                              <div class="col-12 mb-3"
                                   [formGroup]="form">
                                   <label for="email"
                                          class="form-label">
                                        <span [innerHtml]="'EmailAddressLabel' | translator: 'base'">
                                             Email Address
                                        </span><span class="text-danger text-center ms-1"
                                              [title]="'Required' | translator: 'base'">*</span>
                                   </label>
                                   <input formControlName="email"
                                          [title]="'EmailAddressLabel' | translator: 'base'"
                                          class="bg-light form-control w-100"
                                          type="text"
                                          id="driverEmail"
                                          name="driverEmail"
                                          required
                                          maxLength="100"
                                          (change)="emailChanged()" />
                                   <span *ngIf="(email!.invalid && email!.dirty) || hasEmailInUseError"
                                         class="help-block text-danger">
                                        <span *ngIf="email!.errors?.['required']"
                                              [innerHtml]="'Required' | translator: 'base'">
                                             Required.
                                        </span>
                                        <span *ngIf="email!.errors?.['pattern']"
                                              [innerHtml]="'User_Email_invalid' | translator: 'base'">
                                             Email is invalid.
                                        </span>
                                        <span *ngIf="email!.errors?.['maxlength']"
                                              [innerHtml]="'DriverEmail_max' | translator: 'base'">
                                             Email must be 100 characters or less.
                                        </span>
                                        <p *ngIf="hasEmailInUseError"
                                           class="mb-0">
                                             <span class="d-block"
                                                   [innerHtml]="'EmailInUseDriver_1' | translator: 'base'">
                                                  This email address is already in use. Please call PSP help at <a
                                                     href="tel:877-642-9499"
                                                     title="tel:877-642-9499"
                                                     name="877-642-9499">1-877-642-9499</a> or email <a
                                                     href="mailto:PSPhelp@tylertech.com"
                                                     title="PSPhelp@tylertech.com"
                                                     name="helpEmail">PSPhelp&#64;tylertech.com</a>.
                                             </span>
                                        </p>
                                   </span>
                              </div>
                         </div>

                         <div class="row gx-2">
                              <div class="col-12"
                                   [formGroup]="form">
                                   <label for="driverConfirmEmail"
                                          class="form-label">
                                        <span [innerHtml]="'ConfirmEmailAddress' | translator: 'base'">
                                             Confirm Email Address
                                        </span><span class="text-danger text-center ms-1"
                                              [title]="'Required' | translator: 'base'">*</span>
                                   </label>
                                   <input formControlName="confirmEmailInput"
                                          [title]="'ConfirmEmailAddress' | translator: 'base'"
                                          class="bg-light form-control w-100"
                                          type="text"
                                          id="driverConfirmEmail"
                                          name="driverConfirmEmail"
                                          required
                                          maxLength="100"
                                          (change)="confirmEmailChanged()" />
                                   <span *ngIf="(confirmEmailInput!.invalid && confirmEmailInput!.dirty) || hasEmailMismatchError"
                                         class="help-block text-danger">
                                        <span *ngIf="confirmEmailInput!.errors?.['required']"
                                              [innerHtml]="'Required' | translator: 'base'">
                                             Required.
                                        </span>
                                        <span *ngIf="hasEmailMismatchError"
                                              [innerHtml]="'EmailMismatchError' | translator: 'base'">
                                             Emails do not match!
                                        </span>
                                   </span>
                              </div>
                         </div>

                         <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                              <div class="btn-group"
                                   role="group">
                                   <button [routerLink]="service.continueLinkRoute(2)"
                                           (click)="scrollToTop()"
                                           class="btn btn-primary btn-strong"
                                           [title]="'Continue' | translator: 'base'"
                                           [innerHtml]="'Continue' | translator: 'base'"
                                           [disabled]="(form.status === 'INVALID' || pageValid() === false)"
                                           name="driverNext"
                                           id="driverNext">
                                        Continue
                                   </button>
                              </div>

                              <div class="btn-group"
                                   role="group">
                                   <button [routerLink]="service.backLinkRoute(2)"
                                           (click)="scrollToTop()"
                                           class="btn btn-outline-primary"
                                           [title]="'Back' | translator: 'base'"
                                           [innerHtml]="'Back' | translator: 'base'"
                                           name="driverBack"
                                           id="driverBack">
                                        Back
                                   </button>
                                   <button [routerLink]="service.cancelLinkRoute()"
                                           tag="button"
                                           class="btn btn-light"
                                           (click)="scrollToTop()"
                                           name="driverCancel"
                                           id="driverCancel"
                                           [innerHtml]="'Cancel' | translator: 'base'"
                                           [title]="'Cancel' | translator: 'base'">
                                        Cancel
                                   </button>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard *ngIf="wizard"     
                          [wizardObj]="wizard"
                          [activeStep]="1"
                          pageType="driver"
                          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>